import { create } from 'zustand';
import type { ListActivePaymentDto } from '../../generated-api';

interface ActivePaymentStoreState {
  payments: ListActivePaymentDto[];
  actions: {
    setPayments: (payments: ListActivePaymentDto[]) => void;
    addPayment: (payment: ListActivePaymentDto) => void;
    removePayment: (payment: ListActivePaymentDto) => void;
    updatePaymentReference: (paymentMethodId: string, updated: ListActivePaymentDto) => void;
  };
}

export const useActivePaymentStore = create<ActivePaymentStoreState>((set) => ({
  actions: {
    addPayment: (payment) => set((s) => ({ payments: [...s.payments, payment] })),
    removePayment: (payment) =>
      set((s) => ({
        payments: s.payments.filter((ap) => ap.paymentReference !== payment.paymentReference),
      })),
    setPayments: (payments) => set({ payments }),
    updatePaymentReference: (paymentMethodId, updated) =>
      set((s) => ({
        payments: s.payments.map((ap) =>
          ap.paymentMethod.id === paymentMethodId && !ap.paymentReference ? updated : ap
        ),
      })),
  },
  payments: [],
}));
